import { Injectable } from '@angular/core';
import {throwError } from 'rxjs';
import { map,catchError,finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Dep } from '../comm/class/auth';
import { environment } from '../../environments/environment';
import { PerfService } from './perf.service';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,HttpResponse
} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class HttpcontrollerService {
  constructor(private router: Router, private perf: PerfService){}
  public intercept(req: HttpRequest<any>, next: HttpHandler): any {
    const type = req.body?.httptype;
    // console.log(type);
    let new_req;
    if(!type){
      let url = req.url;
      url = environment.serverurl + url;
      new_req = req.clone({
        url: url,
        body: {...req.body, token:Dep.token }
      });
    }else{
      new_req = req.clone({ 
        body: {...req.body, token:Dep.token }});
        // console.log('req',req.url);
    } 

    const perfTok = this.perf.reqStart(req.url);
    return next.handle(new_req)
    .pipe(
      map(response => {
       if(response.type==4){
        let resp = response as HttpResponse<any>;
        const body = resp.body 
        if(!body.status){
          if(body.info?.status_code==3 && typeof(Dep.getData()?.partner)!='undefined'){
            if(Dep.getData().partner==1){
              this.router.navigate(['/', 'agentmember']);
            }else{
              this.router.navigate(['/', 'home']);
            }
          }else{
            Dep.faild(body);
          }
        }else{
          if(body.info?.fresh_token?.length>0){
            Dep.setData(body.info.fresh_token);
          }
        }
       }
        return response;
      }),
      catchError((error) => {
        const res = {status:false,msg:error?.error?.error,detail:error?.error?.text};
        return throwError(error);
      }),
      finalize(() => this.perf.reqEnd(perfTok))
    )
  }
}
